import React from "react";
import { Link } from "react-router-dom";
import "./AuthPage.css"; // Import shared styles

const AuthPage = () => {
  return (
    <div className="auth-container">
      <div className="auth-form">
        <h2>Welcome</h2>
        <p>Choose an option to get started:</p>
        <button className="auth-button">
          <Link to="/auth/signup" className="auth-link">
            Sign Up with Email
          </Link>
        </button>
        <button className="auth-button">
          <Link to="/auth/login" className="auth-link">
            Log In 
          </Link>
        </button>
        <button className="auth-button">
          <Link to="/games" className="auth-link">
            Continue as Guest
          </Link>
        </button>
      </div>
      <img src="/auth-image-16.png" alt="Auth Illustration" className="auth-image" />
      <div className="auth-dots">
        <div className="dot active"></div>
        <div className="dot"></div>
        <div className="dot"></div>
        <div className="dot"></div>
      </div>
    </div>
  );
};

export default AuthPage;
